import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import LoadingSpinner from "../../Common/Spinner";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";

export default function TakePaymentsCheckoutForm({
  callBackAfterPaymentSuccess,
  loading,
  amountToCharge,
  buttonLabel = "Pay & Place Order",
  fullWidthButton = true,
  ecommerceStrict = false,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Only used when ecommerceStrict is true
  const [peReady, setPeReady] = useState(false);
  const [peComplete, setPeComplete] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);
    if (ecommerceStrict) {
      const { error: submitErr } = await elements.submit();
      if (submitErr) {
        setIsLoading(false);
        return;
      }
    }

    const {
      error,
      // returned data
      paymentIntent,
    } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: "if_required",
    });
    console.log(stripe);
    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (!isEmpty(error)) {
      if (error?.type === "card_error" || error?.type === "validation_error") {
        setMessage(error?.message);
        toast.error(error?.message, {
          autoClose: 5000,
        });
      } else {
        setMessage("An unexpected error occurred.");
        toast.error("An unexpected error occurred. " + error?.message, {
          autoClose: 5000,
        });
      }
    }

    setIsLoading(false);
    //
    if (paymentIntent?.status === "requires_capture") {
      callBackAfterPaymentSuccess(paymentIntent?.id);
    }
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement
          id="payment-element"
          options={paymentElementOptions}
          onReady={ecommerceStrict ? () => setPeReady(true) : undefined}
          onChange={
            ecommerceStrict ? (e) => setPeComplete(!!e?.complete) : undefined
          }
        />
        {isLoading || loading ? (
          <LoadingSpinner />
        ) : (
          <div className={"d-flex justify-content-end align-items-center mt-2"}>
            {amountToCharge && (
              <span className={"me-2"}>
                {" "}
                <span className={"me-1 fw-semibold"}>Total:</span> £
                {amountToCharge}
              </span>
            )}

            <button
              disabled={
                isLoading ||
                !stripe ||
                !elements ||
                (ecommerceStrict && (!peReady || !peComplete))
              }
              id="submit"
              className={`btn btn-success ${fullWidthButton ? "w-100" : ""}`}
            >
              <span id="button-text">
                {isLoading || loading ? "Processing…" : buttonLabel}
              </span>
            </button>
          </div>
        )}

        {/* Show any error or success messages */}
        {message && (
          <div
            id="payment-message"
            className={"mt-2 text-danger fw-semibold text-center"}
          >
            {message}
          </div>
        )}
      </form>
      {/* [DEV]: Display dynamic payment methods annotation and integration checker */}
    </>
  );
}
